import { Icon } from '@rbilabs/universal-components';

import Link from 'components/link';
import { SAFE_AREA_TOP_INSET } from 'components/modal/constants';
import { withTypography } from 'components/ui';
import { primitive } from 'styles/constants';

import theme from './theme';

export const InnerText = withTypography({
  color: theme.innerColor,
  lineHeight: theme.innerLineHeight,
  variant: 'copyTwo',
  numberOfLines: 2,
});

export const InnerHeader = withTypography({
  color: primitive.$bbqBrown,
  lineHeight: 'lg',
  variant: 'headerTwo',
  focusable: true,
  style: {
    textTransform: 'capitalize',
  },
});

export const AmenityIcon = Icon.withConfig({
  color: primitive.$bbqBrown,
});

export const PhoneNumber = Link.withConfig({
  color: theme.phoneNumberColor,
  fontSize: 13,
  fontWeight: '400',
  isInline: true,
  isUnderlined: true,
});

export const STORE_INFO_MAP_HEIGHT = 175 + SAFE_AREA_TOP_INSET;
